import { Button, Text } from '@/components/primitives';
import { subtleActionButtonClass, subheaderButtonClass } from '@/components/primitives/Button/button.css';
import { ErrorScreenLayout } from './ErrorScreenLayout';

export interface NoticeScreenAction {
  label: string;
  /** Navigation handler — may be async (react-router's `navigate` can return a Promise). */
  onClick: () => void | Promise<void>;
}

export interface NoticeScreenProps {
  /** Contextual heading, e.g. "Page not found". */
  title: string;
  /** Contextual explanation. */
  message: string;
  /** Badge character. Default '?'. */
  icon?: string;
  /** Badge background colour. */
  iconBgColor?: string;
  primaryAction: NoticeScreenAction;
  secondaryAction?: NoticeScreenAction;
  testId?: string;
}

/**
 * Full-page screen for the "we know what happened" class — 404/403 and other
 * 4xx route responses. A known outcome with a meaningful next step, NOT a
 * crash: no trace id, no telemetry, no debug panel.
 */
export function NoticeScreen({
  title,
  message,
  icon = '?',
  iconBgColor = '#fef9ec',
  primaryAction,
  secondaryAction,
  testId,
}: NoticeScreenProps) {
  return (
    <ErrorScreenLayout icon={icon} iconBgColor={iconBgColor} testId={testId}>
      <Text variant="cardTitle" style={{ fontWeight: 600, marginBottom: 1 }}>
        {title}
      </Text>

      <Text color="secondary" style={{ marginBottom: 24, lineHeight: 1.6 }}>
        {message}
      </Text>

      <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
        {secondaryAction && (
          <Button
            onClick={secondaryAction.onClick}
            className={subtleActionButtonClass}
            style={{ borderRadius: 0, paddingLeft: 20, paddingRight: 20 }}
          >
            {secondaryAction.label}
          </Button>
        )}
        <Button
          onClick={primaryAction.onClick}
          className={subheaderButtonClass}
          style={{ height: 32, borderRadius: 0, paddingLeft: 20, paddingRight: 20, fontSize: 13 }}
        >
          {primaryAction.label}
        </Button>
      </div>
    </ErrorScreenLayout>
  );
}
